(function() {
  'use strict';

  angular
    .module('contentPlayer.cModuleIntro', [])
    .controller('CModuleIntroCtrl', CModuleIntroCtrl);

  CModuleIntroCtrl.$inject = ['$scope', 'Utils'];

  function CModuleIntroCtrl($scope, Utils) {
    $scope.emailTrainer = function() {
      var email = $scope.cModule.trainerEmail;
      Utils.email(email);
    };
  }
})();
